module.exports = __webpack_public_path__ + "static/media/block-1-sunnybank.2fada159.png";